import { Calendar } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";

const DAYS_PRESETS = [
  { value: 7, label: "7 days" },
  { value: 14, label: "14 days" },
  { value: 30, label: "30 days" },
  { value: 60, label: "60 days" },
  { value: 90, label: "90 days" },
  { value: 365, label: "365 days" },
];

interface InsightsDateRangeSelectorProps {
  days: number;
  onDaysChange: (days: number) => void;
}

export function InsightsDateRangeSelector({ days, onDaysChange }: InsightsDateRangeSelectorProps) {
  const currentValue = String(days);
  const currentLabel = DAYS_PRESETS.find((p) => p.value === days)?.label ?? `${days} days`;

  return (
    <div className="flex items-center gap-2" data-testid="insights-date-range-selector">
      <span className="text-xs text-muted-foreground">Data Period:</span>
      <Select value={currentValue} onValueChange={(v) => onDaysChange(Number(v))}>
        <SelectTrigger className="w-[130px]" data-testid="select-insights-days">
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4 text-muted-foreground shrink-0" />
            <span className="truncate">{currentLabel}</span>
          </div>
        </SelectTrigger>
        <SelectContent>
          {DAYS_PRESETS.map((opt) => (
            <SelectItem key={opt.value} value={String(opt.value)}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
